<div class="chart-wrapper">
    <canvas baseChart chartType="pie" [data]="chartData" [colors]="chartColors" [labels]="chartLabels" [options]="chartOptions" [plugins]="chartPlugins" [legend]="chartLegend">
  </canvas>
</div>